import React from 'react'
import {
  CloseButton,
  ModalContainer,
  Header,
  Body,
  ModalFooter,
  SnoozeContainer,
  Description,
} from './style'
import { Container } from 'react-bootstrap'
import { Button, StandardCheckbox } from 'components'

const ReviewScholarshipsModal = ({ show, onHide, translate, onSnooze, onUpdate, onShow }) => {
  return (
    <ModalContainer
      show={show}
      onHide={onHide}
      backdrop="static"
      onShow={onShow}
    >
      <Header closeButton>{translate('review_scholarships_title')}</Header>
      <Body>
        <Container>
          <Description>
            {translate('review_scholarships_container')}
          </Description>
        </Container>
      </Body>
      <ModalFooter>
        <Button onClick={onUpdate}>Update</Button>
        <CloseButton variant="link" onClick={onHide}>
          Close
        </CloseButton>
      </ModalFooter>
      <SnoozeContainer>
        <StandardCheckbox label={translate('review_scholarships_snooze')} onChange={(e) => onSnooze(e)} />
      </SnoozeContainer>
    </ModalContainer>
  )
}

export default ReviewScholarshipsModal
